<template>
    <div class="row">
        <div class="col-md-12 col-sm-8" v-if="title">
            <h3 :style="'font-size:' + font_size + 'px; text-align: ' + text_align + ';'">
                <b>Datos legales: </b>
            </h3> 
        </div>

        <div class="col-md-12 col-sm-8 mt-3">
            <div class="form-group pb-1">
                <div class="checkbox-container mb-4">
                    <input 
                        type="checkbox" 
                        :name="'privacidad' + index" 
                        :id="'privacidad' + index" 
                        v-model="abono.privacidad" 
                        checked 
                        disabled 
                    />
                    <label :for="'privacidad' + index">
                        <span>{{ $t('formularios.he_leido') }}&nbsp;</span>
                        <router-link :to="{ name: 'legal' }" target="_blank">
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link>
                        y la
                        <router-link :to="{ name: 'privacidad' }" target="_blank">
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
            </div>

            <div class="form-group pb-1">
                <div class="checkbox-container mb-4">
                    <input 
                        type="checkbox" 
                        :name="'condiciones' + index" 
                        :id="'condiciones' + index" 
                        v-model="abono.condiciones" 
                        checked 
                        disabled 
                    />
                    <label for="condiciones">{{ $t('formularios.acepto') }}
                        <router-link :to="{ name: 'condiciones_generales'}" target="_blank">
                            <span>{{ $t('formularios.condiciones') }}</span>
                        </router-link>
                    </label>
                </div>
            </div>

            <div class="form-group pb-1">
                <div class="checkbox-container mb-4 div-wrap">
                    <input 
                        type="checkbox" 
                        :name="'comunicaciones'+ index" 
                        :id="'comunicaciones' + index" 
                        v-model="abono.comunicaciones" 
                        checked 
                        :disabled="disabled" 
                    />
                    <label :for="'comunicaciones'+ index">{{ $t('formularios.acepto_comunicaciones', { teatro: teatro.nombre }) }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            abono: { type: Object, required: true },
            index: { type: [Number, String], required: true },
            title: { type: String, default: '' },
            font_size: { type: String, default: '16' },
            text_align: { type: String, default: 'left' },
            disabled: { type: Boolean, default: false }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
    }
</script>

<style scoped>
    @media (max-width: 768px) {    
        .div-wrap {
            flex-wrap: wrap;
            padding-bottom: 20px;
        }
    }
</style>